module.exports = __webpack_public_path__ + "5b2bb4f549de1c7cb5bc69d80005e5c0.svg";